import * as yup from "yup";

import { CantidadSchema } from "./CantidadSchema";
import { CASRegex } from "../utils/regex";

export const TanqueAcopioLiquidoSchema = yup.object().shape({
  orden: yup
    .number()
    .min(0, "errors.cantidad.magnitud.min")
    .required("errors.tanqueAcopioLiquido.orden.required"),
  sustanciaQuimica: yup
    .object()
    .shape({
      nombreComercial: yup
        .string()
        .max(
          100,
          "errors.tanqueAcopioLiquido.sustanciaQuimica.nombreComercial.max",
        )
        .required(
          "errors.tanqueAcopioLiquido.sustanciaQuimica.nombreComercial.required",
        )
        .default(""),
      CAS: yup
        .string()
        .transform((value) => (value === "" ? null : value))
        .nullable()
        .test(
          "cas.required",
          "errors.tanqueAcopioLiquido.sustanciaQuimica.CAS.required",
          (value) => value != null && value !== "",
        )
        .test(
          "cas.format",
          "errors.tanqueAcopioLiquido.sustanciaQuimica.CAS.regEx",
          (value) => !value || CASRegex.test(value),
        )
        .max(20, "errors.tanqueAcopioLiquido.sustanciaQuimica.CAS.max")
        .default(null),
    })
    .required("errors.tanqueAcopioLiquido.sustanciaQuimica.required"),
  alturaLiquido: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.tanqueAcopioLiquido.alturaLiquido.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M" } }),
  clasificacion: yup
    .object()
    .required("errors.tanqueAcopioLiquido.clasificacion.required")
    .default(null),
  altura: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.tanqueAcopioLiquido.altura.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M" } }),
  diametro: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.tanqueAcopioLiquido.diametro.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M" } }),
  volumenOperacional: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.tanqueAcopioLiquido.volumenOperacional.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ unidad: { codigo: "M3" } }),
  volumenTotal: yup
    .object()
    .concat(CantidadSchema)
    .required("errors.tanqueAcopioLiquido.volumenTotal.required")
    .test("magnitud.min", "errors.cantidad.magnitud.min", (value, context) => {
      return value?.magnitud > 0;
    })
    .default({ magnitud: 0, unidad: { codigo: "M3" } }),
});
